import analytics from '../index';

async function trackSelectionEvents(fieldId, fieldName, selected, type) {
  const selectionPayload = {
    field_id:   fieldId,
    field_name: fieldName,
    field_type: type,
    selected,
  };

  await analytics.track('selection', selectionPayload);
}

function handleChangeEvent(e) {
  const { target } = e;

  const {
    id, name, checked, type,
  } = target;

  trackSelectionEvents(id, name, checked, type);
}

function addSelectionSelectedEventListeners() {
  const inputs = document.querySelectorAll('input[type=checkbox], input[type=radio]');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].addEventListener('change', handleChangeEvent);
  }
}

function removeSelectionSelectedEventListeners() {
  const inputs = document.querySelectorAll('input[type=checkbox], input[type=radio]');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].removeEventListener('change', handleChangeEvent);
  }
}

export {
  addSelectionSelectedEventListeners,
  removeSelectionSelectedEventListeners,
  handleChangeEvent,
};
